<mat-card class=" ">
    <mat-card-header class="titreFrm">
      <mat-card-title>LISTE {{collaborateurs}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">

    <div *ngIf="exist;else attente"></div>
    <ng-template #attente>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
    <div class="btn" >
     
        <!-- <div  style="margin-right: 20px" class="button-row">
          <button (click)="planning()" mat-raised-button class="colorGreen">Planning</button>
        </div> -->
        <div *ngIf="!showButton" class="button-row">
          <button  type="button" [disabled]="!exist" (click)="choisirDocument()"
            mat-raised-button class="colorGreen button-row">
            <mat-icon>mouse</mat-icon>Choisir
          </button>
        </div>
        <div *ngIf="!showButton" class="button-row">
          <button  type="button" [disabled]="!exist" (click)="generalService.dialogOpend.close()"
            mat-raised-button class="colorRed button-row">
            <mat-icon>close</mat-icon>Fermer
          </button>
        </div>
        <div *ngIf="showButton" class="button-row">
            <button (click)="afficher(2)" [disabled]="!exist" mat-raised-button class="colorBlue">
            <mat-icon>edit</mat-icon>
            Modifier
          </button>
        </div>
        <div *ngIf="showButton" class="button-row">
          <button (click)="afficher(3)" [disabled]="!exist" mat-raised-button class="colorGray">
            <mat-icon>import_contacts</mat-icon>
            Consulter
          </button>
        </div>
        <div *ngIf="showButton" class="button-row">
           <button (click)="supprimer()" [disabled]="!exist" mat-raised-button class="colorRed">
            <mat-icon>delete</mat-icon>
            Supprimer
          </button>
        </div>
        
      <div class="button-row">
        <button   type="button" [disabled]="!exist" (click)="exportToExcel()" mat-raised-button class="colorGreen"><mat-icon>arrow_downward</mat-icon>Export Excel</button>
      </div>
    </div>
    <div *ngIf="showTableColl">
        <app-avt-listes [multipleSelect]="false" #listeCollComponen [showFilter]="true" [heightTable]="'400'" [dataSourceBrut]="dataSource" [displayedColumnsBrut]="columns" ></app-avt-listes>
      </div>
  </mat-card-content>
</mat-card>
